import { tagKurz, uhrImBetrieb } from "./betriebstag";
/* ══════════════ Wann — die Zeitangabe einer Aufgabe ══════════════
   Aus `bausteine/Vorbereitung.tsx` hierher gezogen (D-01, 03.10.2026), damit
   sie ohne React prüfbar ist. Die Maske re-exportiert sie unter dem alten
   Namen. */

type Satz = (pfad: string, werte?: Record<string, string | number>) => string;


/* Uhrzeit und Tag in deutscher Zeit (N8-02). Ein reiner Tag hat keine Uhrzeit. */
const uhr = (iso: string): string => uhrImBetrieb(iso);
const tag = (iso: string): string => tagKurz(iso);

/**
 * „heute 07:30", „morgen 07:30", „am 05.10. 07:30", „seit 13.10." — die
 * Zeitangabe einer Aufgabe. `tage` rechnet der Server in der Zeitzone des
 * Betriebs; hier wird nur geschrieben.
 *
 * **Auch der spätere Tag trägt die Uhrzeit** (D-01, 03.10.2026): Am Telefon
 * stand in der Zeitspalte „05.10." und darunter nur „am" — die Spalte setzt
 * den letzten Teil mit einer Ziffer nach oben und den Rest leise darunter.
 * Jetzt steht oben die Uhrzeit und darunter „am 05.10.", wie bei „heute"
 * und „morgen". Mitternacht ist keine Uhrzeit, sondern ein Tag ohne eine —
 * dann bleibt es bei „am 05.10.".
 */
export function wannText(t: Satz, iso: string | null, tage: number | null): string {
  if (!iso) return "";
  if (tage === 0) return t("aufgaben.heute", { uhr: uhr(iso) });
  if (tage === 1) return t("aufgaben.morgen", { uhr: uhr(iso) });
  if (tage !== null && tage < 0) return t("aufgaben.seit", { tag: tag(iso) });
  const u = uhr(iso);
  return u && u !== "00:00"
    ? t("aufgaben.amUm", { tag: tag(iso), uhr: u })
    : t("aufgaben.am", { tag: tag(iso) });
}
